const utmFields = ['utm_medium', 'utm_source', 'utm_campaign', 'utm_content', 'utm_term']

export const storeUtmData = () => {
    try {
        const searchParams = new URLSearchParams(window.location.search)

        if (searchParams.has('utm_medium') && searchParams.has('utm_source')) {
            const utmData = utmFields.map((field) => ({
                name: field,
                value: searchParams.get(field) || '',
            }))

            sessionStorage.setItem('utmData', JSON.stringify(utmData))
        }
    } catch (error) {
        console.error('error storing utm data', error)
    }
}

export const getUtmData = () => {
    try {
        const utmData = sessionStorage.getItem('utmData')
        const parsedUtmData: { name: string; value: string }[] = utmData ? JSON.parse(utmData) : []
        const utm: { [x: string]: string } = {}
        parsedUtmData.forEach((field) => {
            utm[field.name] = field.value
        })
        return utm
    } catch (error) {
        console.error('error getting utm data', error)
        return null
    }
}
